import { useQuery } from '@tanstack/react-query';
import { getQueue } from '../../services/queue';
import useUser from '../global/useUser';
import { QueueAppointment } from '../../types/queue';
import { userHasAccessToQueue } from '../../helpers/queue';

function useGetQueue({
  enabled = true,
  onSuccess,
}: {
  enabled?: boolean;
  onSuccess?: (queue: Awaited<ReturnType<typeof getQueue>>) => void;
} = {}) {
  const { user } = useUser();

  const {
    data: queue,
    isLoading,
    isFetching,
    isError,
    error,
    refetch,
    isRefetching,
    fetchStatus,
  } = useQuery<QueueAppointment[]>({
    queryKey: ['queue', user?.business?.id],
    queryFn: async () => {
      if (!user?.business?.id) {
        throw new Error('Business ID is required');
      }
      const result = await getQueue(user.business.id);

      onSuccess?.(result);

      return result;
    },
    enabled: !!user?.business?.id && userHasAccessToQueue(user) && enabled,
  });

  return {
    queue,
    isLoading,
    isFetching,
    isError,
    error,
    refetch,
    isRefetching,
    // Query is enabled but not fetching because the browser reports offline
    isPaused: fetchStatus === 'paused',
  };
}

export default useGetQueue;
